module.exports = __webpack_public_path__ + "img/bg_tai@2x.2fc37eca.png";